import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app/app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MsalInterceptor, MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache } from '@apollo/client/core';
import { MSAL_INSTANCE, MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';
import { MSALInstanceFactory, MSALGuardConfigFactory, MSALInterceptorConfigFactory } from './msal-config';
import { environment } from './environments/environment';
import { importProvidersFrom, inject, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AuthInterceptor } from './shared/services/auth-interceptor';
import { NgxEchartsModule } from 'ngx-echarts';
const env = environment.hasuraUrl;
bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(
      NgxEchartsModule.forRoot({
        echarts: () => import('echarts')
      })
    ),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideApollo(() => {
      const httpLink = inject(HttpLink);
      return {
        cache: new InMemoryCache(),
        link: httpLink.create({ uri: env + 'profiling-hasura/v1/graphql' })
      };
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalBroadcastService,
    { provide: 'list', useValue: 'ListManagement' },
    { provide: 'role', useValue: 'RoleManagement' },
    { provide: 'tenant', useValue: 'TenantManagement' },
    { provide: 'user', useValue: 'UserManagement' },
    { provide: 'job', useValue: 'JobManagement' },
    { provide: 'func', useValue: 'FunctionManagement' },
    { provide: 'db', useValue: 'DBConnectionManagement' },
    { provide: 'profjob', useValue: 'ProfilingJobManagement' },
    { provide: 'profhistory', useValue: 'ProfilingHistoryManagement' },
    { provide: 'profresults', useValue: 'ProfilingResultManagement' },
    { provide: 'ruleassignment', useValue: 'funRuleAssignment' }
  ]
});
